import { NavLink, Outlet } from "react-router-dom";
import { LayoutGrid, BookOpen, Wallet, Users, GraduationCap, Settings, ArrowRight, Film } from "lucide-react";
import { Logo } from "@/components/site/Navbar";
import { useSeo } from "@/lib/seo";

const NAV = [
  ["", "نظرة عامة", LayoutGrid, "overview"],
  ["courses", "الكورسات", BookOpen, "courses"],
  ["payments", "طلبات الدفع", Wallet, "payments"],
  ["students", "الطلاب", Users, "students"],
  ["enrollments", "الاشتراكات والتقدم", GraduationCap, "enrollments"],
  ["reels", "أعمال المتدربين", Film, "reels"],
  ["settings", "الإعدادات", Settings, "settings"],
];

export default function AdminLayout() {
  useSeo("لوحة الأدمن");
  return (
    <div className="min-h-screen bg-[var(--kh-ws)] text-slate-100 lg:flex" data-testid="admin-layout">
      <aside className="lg:w-64 lg:min-h-screen bg-[var(--kh-ws-card)] border-l border-white/5 lg:sticky lg:top-0 lg:h-screen">
        <div className="p-5 flex items-center justify-between lg:block"><Logo onDark />
          <span className="lg:mt-3 lg:block text-xs text-yellow-300">لوحة الإدارة</span>
        </div>
        <nav className="flex lg:flex-col gap-1 px-3 pb-3 overflow-x-auto">
          {NAV.map(([to, label, Icon, id]) => (
            <NavLink key={id} to={`/admin${to ? `/${to}` : ""}`} end={!to} data-testid={`admin-nav-${id}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm whitespace-nowrap transition-colors ${isActive ? "bg-[var(--kh-violet)] text-white" : "text-slate-400 hover:text-white hover:bg-white/5"}`}>
              <Icon size={18} />{label}
            </NavLink>
          ))}
          <NavLink to="/" className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-slate-500 hover:text-white whitespace-nowrap"><ArrowRight size={18} />الموقع</NavLink>
        </nav>
      </aside>
      <main className="flex-1 p-4 sm:p-8 min-w-0"><Outlet /></main>
    </div>
  );
}
